import { useMutation, useQueryClient } from '@tanstack/react-query';
import { autoAllocate, bookAllPlan } from '@/lib/bulk-allocation/api';
import type { AllocationPlan, BookAllResponse } from '@/lib/bulk-allocation/types';

// Bulk allocation hooks — the DEFAULT path (product-owner Task #9):
//   1. useAutoAllocate → build the plan (books nothing). The component keeps the
//      returned plan in state and renders the review table.
//   2. useBookAll      → book every plan item in one batch. On success we
//      invalidate the reservations query so the assignment board / counts
//      reflect the newly-BOOKED rows (the reservations poll then settles them).

export function useAutoAllocate(caseUrn: string, airportCode: string) {
  return useMutation<AllocationPlan>({
    mutationFn: () => autoAllocate(caseUrn, { airportCode }),
  });
}

export function useBookAll(caseUrn: string, airportCode: string) {
  const qc = useQueryClient();
  return useMutation<BookAllResponse, Error, AllocationPlan>({
    mutationFn: (plan) => bookAllPlan(caseUrn, plan, { airportCode }),
    onSuccess: () => {
      // Books are async (202 → PENDING); kick the reservations poll so booked
      // groups advance to BOOKED on their own.
      void qc.invalidateQueries({ queryKey: ['cases', caseUrn, 'reservations'] });
    },
  });
}
